import React, { useEffect } from 'react';
import Reveal from '../components/Reveal';

const Section = ({ title, children, i = 0 }) => (
  <Reveal delay={(i % 3) * 0.08} y={40}>
    <div className="mb-8">
      <h2 className="font-display text-2xl sm:text-3xl text-[#1a1a1a] mb-3">{title}</h2>
      <div className="font-body text-[#4a463d] leading-relaxed space-y-3">{children}</div>
    </div>
  </Reveal>
);

const Privacy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div>
      <section className="bg-[#0b0b0b] py-20 sm:py-24 text-center">
        <Reveal>
          <p className="overline text-gold-gradient mb-3">Your Trust Matters</p>
          <h1 className="font-display text-5xl sm:text-6xl text-[#f7f3ec] underline-grow">Privacy Policy</h1>
        </Reveal>
      </section>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Reveal><p className="font-body text-sm text-[#6b6459] mb-10">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p></Reveal>
        <Section title="Overview" i={0}>
          <p>At Nikki’s Next Level Hair and Beauty, your privacy is a priority. This policy explains what information we collect, how we use it, and the choices you have when you shop with us.</p>
        </Section>
        <Section title="Information We Collect" i={1}>
          <p>We collect information you provide directly — such as your name, email, phone number, shipping address, and payment details — when you place an order, contact us, or subscribe to our newsletter. We also collect limited technical data such as browser type and pages visited to improve your experience.</p>
        </Section>
        <Section title="How We Use Your Information" i={2}>
          <p>Your information is used to process and ship orders, respond to inquiries, send order updates, and — with your consent — share promotions and new product drops. We never sell your personal information.</p>
        </Section>
        <Section title="Payments & Security" i={3}>
          <p>Payments are processed securely through our trusted payment provider. We do not store full card numbers on our servers. Reasonable safeguards are in place to protect your data.</p>
        </Section>
        <Section title="Your Choices" i={4}>
          <p>You may opt out of marketing emails at any time via the unsubscribe link. To request access to or deletion of your data, contact us at brooke.knight@nikkisnextlevel.com.</p>
        </Section>
        <Section title="Contact" i={5}>
          <p>Questions about this policy? Email brooke.knight@nikkisnextlevel.com or call 1 (888) 989-1908.</p>
        </Section>
      </div>
    </div>
  );
};

export default Privacy;
